var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6847_63124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.667 9.33073H17.3337V11.9974H14.667V9.33073ZM14.667 14.6641H17.3337V22.6641H14.667V14.6641ZM16.0003 2.66406C8.64033 2.66406 2.66699 8.6374 2.66699 15.9974C2.66699 23.3574 8.64033 29.3307 16.0003 29.3307C23.3603 29.3307 29.3337 23.3574 29.3337 15.9974C29.3337 8.6374 23.3603 2.66406 16.0003 2.66406ZM16.0003 26.6641C10.1203 26.6641 5.33366 21.8774 5.33366 15.9974C5.33366 10.1174 10.1203 5.33073 16.0003 5.33073C21.8803 5.33073 26.667 10.1174 26.667 15.9974C26.667 21.8774 21.8803 26.6641 16.0003 26.6641Z",
    fill: "url(#paint0_linear_6847_63124)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6847_63124",
    x1: 29.3311,
    y1: 15.8716,
    x2: 1.28234,
    y2: 15.8716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E4969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0173B0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6847_63124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic_info.7253e763ca22172d6be893bfea061707.svg";
export { ForwardRef as ReactComponent };